import { Skeleton } from "../ui/skeleton";

export default function TrackShipmentSkeleton() {
  return (
    <div className="flex flex-col items-center gap-6 px-5 py-7 sm:px-10 sm:py-9 lg:px-14 lg:py-10">
      <div className="flex flex-col items-center gap-4 text-center w-full">
        <Skeleton className="h-6 w-56 sm:h-7 sm:w-64 lg:h-8 lg:w-72" />

        <div className="w-full max-w-[460px] flex flex-col gap-3">
          <Skeleton className="h-11 w-full rounded-full sm:h-12" />
          <Skeleton className="h-3 w-40 sm:h-4 sm:w-48" />
          <div className="flex items-center justify-center gap-2">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-3 w-64 sm:h-4 sm:w-72" />
          </div>
        </div>
      </div>

      <Skeleton className="h-12 sm:h-14 w-full max-w-[340px] rounded-full" />
    </div>
  );
}
